/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TenantsConfig } from '../models/tenants-config';

@Injectable({
  providedIn: 'root',
})
export class TenantsApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getConfigForTenants
   */
  static readonly GetConfigForTenantsPath = '/tenants';

  /**
   * Fetch tenant configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfigForTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigForTenants$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<TenantsConfig>>> {

    const rb = new RequestBuilder(this.rootUrl, TenantsApiService.GetConfigForTenantsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TenantsConfig>>;
      })
    );
  }

  /**
   * Fetch tenant configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfigForTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfigForTenants(params?: {
  },
  context?: HttpContext

): Observable<Array<TenantsConfig>> {

    return this.getConfigForTenants$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<TenantsConfig>>) => r.body as Array<TenantsConfig>)
    );
  }

}
